import React from 'react'
import { Form } from 'react-bootstrap'

export default function Text(props) {

    const { label_name, placeholder, name, value, onChange, onBlur,required, error,maxLength,disabled } = props

    return (
        <>
            <Form.Group className="mb-2" >
                {label_name == '' ? '' : <Form.Label className='form_label'>{label_name}{required == true ? <span className='required_filed'>*</span>:""}</Form.Label>}
                <Form.Control
                    type="text"
                    placeholder={placeholder}
                    className='form_input'
                    name={name}
                    maxLength={maxLength}
                    disabled={disabled}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                />
                {error}

            </Form.Group>
        </>
    )
}
